export default __webpack_public_path__ + "static/media/vincentBankdetail(1).3cf291e1.png";